<template>
    <div class="TopCard">
        <div class="titleBox">
            <div class="left otherHandle"></div>
            <div class="center">我的行为分</div>
            <van-button type="primary" size="small" class="otherHandle" round @click="libnkToGradeDetailed">查看明细</van-button>
        </div>
        <div class="gradeCard">
            <div class="grade" v-text="grade"></div>
        </div>
        <div class="tipBox">
            <div class="tip">
                <div class="title">
                    <i class="iconfont icon" :class="currentGradeTip.icon"></i>
                    {{ currentGradeTip.title }}
                </div>
                <div class="detail" v-text="currentGradeTip.detail"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { Button, Icon } from 'vant'
export default {
  name: 'TopCard',
  components: {
    'van-button': Button,
    'van-icon': Icon
  },
  data () {
    return {
      gradeTipList: [
        {
          status: 1,
          icon: 'icon-ganxie1',
          title: '你的表现棒极了！',
          detail: '你的购物表现十分棒，未出现任何违规记录，请继续保持哦~'
        },
        {
          status: 2,
          icon: 'icon-kuliancopy',
          title: '你的表现有待加强哦~',
          detail: '你存在违规行为，请注意规范购物行为，避免账号受到限制哦~'
        },
        {
          status: 3,
          icon: 'icon-kuliancopy',
          title: '请不要放弃自己！',
          detail: '你存在较多违规行为，行为分已处于警惕分数，请规范购物行为，避免账号封禁，无法继续在搜货省钱养家哦~'
        },
        {
          status: 4,
          icon: 'icon-bugaoxing',
          title: '无法挽救，请三思',
          detail: '由于多次出现违规行为，行为分已清零，你的账号已被封禁，无法继续购物。请面壁思过！'
        }
      ]
    }
  },
  computed: {
    currentGradeTip () {
      let tempStatus = ''
      if (this.grade >= 12) {
        tempStatus = 0
      } else if (this.grade >= 7) {
        tempStatus = 1
      } else if (this.grade >= 1) {
        tempStatus = 2
      } else {
        tempStatus = 3
      }
      return this.gradeTipList[tempStatus]
    }
  },
  props: {
    grade: {
      type: String,
      default: '12.0'
    }
  },
  methods: {
    libnkToGradeDetailed () {
      this.$emit('libnkToGradeDetailed')
    }
  }
}
</script>

<style lang="scss" scoped>
.TopCard {
    margin-bottom: 15px;
}
.titleBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    background-color: #101010;
    color: #fff;
    font-size: 16px;
    padding: 0 10px;
    box-sizing: border-box;
    .otherHandle {
        width: 80px;
        background-color: #ffffff;
        color: #101010;
        border: none;
        font-size: 14px;
    }
}
.gradeCard {
    background-color: #101010;
    .grade {
        color: #fff;
        font-size: 50px;
        font-weight: 700;
        text-align: center;
        height: 80px;
        // line-height: 80px;
    }
}
.tipBox {
    position: relative;
    display: flex;
    justify-content: space-around;
    .tip {
        z-index: 100;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        width: 90%;
        // height: 100px;
        background-color: #fff;
        padding: 15px 15px;
        box-sizing: border-box;
        border-radius: 8px;
        .title {
            display: flex;
            align-items: center;
            line-height: 16px;
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 10px;
            .icon {
                color: #9a9a9a;
                margin-right: 4px;
            }
        }
        .detail {
            font-size: 14px;
            line-height: 22px;
            color: #abacac;
        }
    }
}
.tipBox::after {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 40px;
    background-color: #101010;
    z-index: 1;
}
</style>
